// Public store links for the WooZoo app. Fill APP_STORE_URL with the real
// listing once the app is live on the App Store. Google Play is not launched
// yet, so its link stays empty (the button falls back to "#"). Wiring both
// consumers (hero CTA + nav menu) to these constants means only this file
// changes when the URLs are known.
export const APP_STORE_URL =
  "https://apps.apple.com/fr/app/woozoo-know-whos-who/id6766650651";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=io.woozoo.app&utm_source=emea_Med";
